import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CamionesService } from './../../../../../../../services/API/camiones/camiones.service';
import { MaterialesService } from './../../../../../../../services/API/materiales/materiales.service';

@Component({
  selector: 'app-new-scale',
  templateUrl: './new-scale.component.html',
  styleUrls: ['./new-scale.component.css'],
  standalone: false
})
export class NewScaleComponent implements OnInit {
  form: UntypedFormGroup;
  name: string = "";
  description: string = "";
  active: boolean = true;
  camiones: any[] = [];
  materiales: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<NewScaleComponent>,
    private camionesService: CamionesService,
    private materialesService: MaterialesService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.name, [Validators.required, Validators.minLength(1), Validators.maxLength(124)]],
      description: [this.description, [Validators.maxLength(512)]],
      active: [this.active, [Validators.required]],
      default_id_camion: [null],
      default_id_material: [null],
    });

    this.camionesService.getCamiones('true').subscribe((result: any) => {
      this.camiones = result || [];
    });
    this.materialesService.getMateriales('Pesaje').subscribe((result: any) => {
      this.materiales = result || [];
    });
  }

  save() {
    const { value, valid } = this.form;
    if (valid) {
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
